var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"homeWrapper",staticClass:"templates-wrapper"},[_c('Banner2',{attrs:{"id":"Banner1_0","is-mobile":_vm.isMobile}}),_c('Content7',{attrs:{"id":"Content7_0","is-mobile":_vm.isMobile}}),_c('Content6',{attrs:{"id":"Content6_0","is-mobile":_vm.isMobile}}),_c('Content4',{attrs:{"id":"Content4_0","is-mobile":_vm.isMobile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }